import SEOLandingTemplate from './SEOLandingTemplate';

export default function WhoisCheckerPage() {
  return (
    <SEOLandingTemplate
      title="Whois Lookup"
      metaTitle="Free Whois Lookup | Sungresh"
      metaDescription="Look up domain registration details, registrar, and DNS records for any domain."
      h1="Free Whois Lookup"
      sub="Look up a domain's registrar, registration and expiry dates, nameservers, and DNS records. Owner details are shown only when the domain doesn't have WHOIS privacy enabled."
      keywords="whois lookup, whois checker, domain whois, dns lookup"
      ctaLink="/domain/overview"
      ctaText="Look Up a Domain Free"
      features={[
        { icon: '🔍', title: 'Registration Details', desc: 'Registrar, registration date, and expiry date' },
        { icon: '📅', title: 'Domain Age', desc: 'How long the domain has been registered' },
        { icon: '📡', title: 'DNS Records', desc: 'A, MX, NS, and TXT records' },
      ]}
      faqs={[
        { q: 'Can I see who owns a domain?', a: 'Only if the domain doesn\'t have WHOIS privacy protection enabled. Most domains registered today do use a privacy service, which shows the privacy provider\'s details instead of the actual registrant.' },
        { q: 'Why does domain age matter?', a: 'Older, established domains are often (though not always) viewed as more trustworthy — it\'s one weak signal among many, not a strong ranking factor on its own.' },
        { q: 'What can DNS records tell me?', a: 'They show where a domain\'s traffic and email are actually routed — useful for confirming hosting setup or verifying a domain migration completed correctly.' },
      ]}
    />
  );
}
